if (!customElements.get('collapsible-description')) {
  customElements.define('collapsible-description', class CollapsibleDescription extends HTMLElement {
    connectedCallback() {
      this.maxChars = parseInt(this.dataset.maxChars) || 300;
      this.moreText = this.dataset.moreText || 'Read more';
      this.lessText = this.dataset.lessText || 'Read less';
      this.chevronDown = '<svg class="collapsible-description__icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      this.chevronUp = '<svg class="collapsible-description__icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8L6 4L10 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      this.fullContent = this.innerHTML;
      this.animation = null;
      this.isAnimating = false;
      this.expanded = false;

      // Count text-only length
      var textLength = this.textContent.trim().length;
      if (textLength <= this.maxChars) return;

      this.truncatedContent = this.buildTruncatedHTML();

      // Build initial collapsed view
      this.innerHTML = '<div class="collapsible-description__inner">' + this.truncatedContent + '</div>'
        + this.buildToggleButton(this.moreText, false);
      this.inner = this.querySelector('.collapsible-description__inner');

      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
      var toggle = e.target.closest('.collapsible-description__toggle');
      if (!toggle) return;

      e.preventDefault();

      if (this.isAnimating) return;

      if (this.expanded) {
        this.collapse();
      } else {
        this.expand();
      }
    }

    expand() {
      this.isAnimating = true;

      var startHeight = this.inner.offsetHeight + 'px';
      this.inner.innerHTML = this.fullContent;
      var endHeight = this.inner.offsetHeight + 'px';

      // Update toggle button
      var toggle = this.querySelector('.collapsible-description__toggle');
      toggle.innerHTML = this.lessText + ' ' + this.chevronUp;
      toggle.setAttribute('aria-expanded', 'true');

      this.inner.style.overflow = 'hidden';

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.inner.animate(
        { height: [startHeight, endHeight] },
        { duration: 400, easing: 'ease-out' }
      );

      this.animation.onfinish = function() {
        this.inner.style.height = '';
        this.inner.style.overflow = '';
        this.animation = null;
        this.isAnimating = false;
        this.expanded = true;
      }.bind(this);

      this.animation.oncancel = function() {
        this.isAnimating = false;
      }.bind(this);
    }

    collapse() {
      this.isAnimating = true;

      var startHeight = this.inner.offsetHeight + 'px';
      this.inner.innerHTML = this.truncatedContent;
      var endHeight = this.inner.offsetHeight + 'px';

      // Update toggle button
      var toggle = this.querySelector('.collapsible-description__toggle');
      toggle.innerHTML = this.moreText + ' ' + this.chevronDown;
      toggle.setAttribute('aria-expanded', 'false');

      this.inner.style.overflow = 'hidden';

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.inner.animate(
        { height: [startHeight, endHeight] },
        { duration: 250, easing: 'ease' }
      );

      this.animation.onfinish = function() {
        this.inner.style.height = '';
        this.inner.style.overflow = '';
        this.animation = null;
        this.isAnimating = false;
        this.expanded = false;
      }.bind(this);

      this.animation.oncancel = function() {
        this.isAnimating = false;
      }.bind(this);
    }

    buildToggleButton(text, isExpanded) {
      var icon = isExpanded ? this.chevronUp : this.chevronDown;
      return '<div class="collapsible-description__toggle-wrapper">'
        + '<a href="#" class="collapsible-description__toggle" role="button" aria-expanded="' + (isExpanded ? 'true' : 'false') + '">'
        + text + ' ' + icon
        + '</a>'
        + '</div>';
    }

    buildTruncatedHTML() {
      var temp = document.createElement('div');
      temp.innerHTML = this.fullContent;

      var result = document.createElement('div');
      var charCount = { value: 0 };
      var done = { value: false };

      this.walkAndTruncate(temp, result, charCount, done);

      // Trim trailing whitespace and add ellipsis to the last text node
      var lastTextNode = this.findLastTextNode(result);
      if (lastTextNode) {
        lastTextNode.textContent = lastTextNode.textContent.replace(/\s+$/, '') + '\u2026';
      }

      return result.innerHTML;
    }

    walkAndTruncate(source, target, charCount, done) {
      var children = source.childNodes;

      for (var i = 0; i < children.length; i++) {
        if (done.value) break;

        var node = children[i];

        if (node.nodeType === 3) {
          // Text node
          var text = node.textContent;
          var remaining = this.maxChars - charCount.value;

          if (text.length <= remaining) {
            target.appendChild(document.createTextNode(text));
            charCount.value += text.length;
          } else {
            // Find word-safe break point
            var breakAt = text.lastIndexOf(' ', remaining);
            if (breakAt <= 0) breakAt = remaining;

            var truncated = text.substring(0, breakAt);
            target.appendChild(document.createTextNode(truncated));
            charCount.value += breakAt;
            done.value = true;
          }
        } else if (node.nodeType === 1) {
          // Element node — clone without children
          var clone = node.cloneNode(false);
          target.appendChild(clone);
          this.walkAndTruncate(node, clone, charCount, done);
        }
      }
    }

    findLastTextNode(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var last = null;
      while (walker.nextNode()) {
        if (walker.currentNode.textContent.trim().length > 0) {
          last = walker.currentNode;
        }
      }
      return last;
    }
  });
}
